import styled from 'styled-components'

const PropertyListTitle = styled.h2`
  font-size: ${(p) => p.theme.font.size.xxxl};
  font-weight: bold;
  color: ${(p) => p.theme.FONT_COLOR};
  margin-bottom: 24px;
  line-height: 1.2;
`

export default PropertyListTitle
